import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatNumber, getLink } from "../../utils/helpers";

export default function TopChoferes({ choferes }) {
    const [expandChoferes, setExpandChoferes] = useState(false);

    const maxToneladasChofer = choferes[0] ? choferes[0].toneladas : 0;

    return (
        <div
            className={
                "dashboard-ranking-widget dashboard-top-choferes " +
                (expandChoferes ? "expand" : "")
            }>
            <h2 className='dashboard-widget-title'>Choferes con más tons.</h2>
            <ol className='dashboard-ranking'>
                {choferes.map((chofer, index) => (
                    <li className='dashboard-ranking-item' key={chofer.codigo}>
                        <span className='dashboard-ranking-index'>
                            {index + 1}.
                        </span>
                        <span className='dashboard-ranking-name'>
                            <Link
                                to={getLink(
                                    `/empleados/${chofer.id}/informacion`
                                )}>
                                {chofer.codigo} - {chofer.nombre}{" "}
                                {chofer.apellido[0]}.
                            </Link>
                        </span>
                        <span className='dashboard-ranking-value'>
                            {formatNumber(chofer.toneladas / 1000)}
                        </span>
                        <span
                            className='dashboard-ranking-bar'
                            style={{
                                width:
                                    (100 * chofer.toneladas) /
                                        maxToneladasChofer +
                                    "%",
                            }}></span>
                    </li>
                ))}
            </ol>
            <button
                onClick={() => setExpandChoferes(!expandChoferes)}
                className='show-more-btn'>
                {expandChoferes ? "Ver menos" : "Ver más"}
            </button>
        </div>
    );
}
